export default __webpack_public_path__ + "static/agency-banner-5ae16e62dfcaa23093836196a46ef132.png";